import React from 'react'
import "./advncShiftReportPrint.css"
import "./BillTypeTemplateSummaryThermal.css"
import { useSelector } from 'react-redux'
import { convertToAMPM, today, getCurrentTime } from '../../../../../Js/Date'
const AdvncShiftReportHeader = () => {

  const companyProfile=useSelector((state)=>state.companyProfileSlice?.userValue)
  const {shiftReportDetails, shiftReporCheckinSummary} = useSelector((state) => state.posReportshiftSlice);
  const userInfo = useSelector((state) => state.loginResponseSlice.value);
  
  // Get shift data from localStorage as fallback
  const userShiftStatus = localStorage.getItem("shiftStatus");
  const shiftData = userShiftStatus ? JSON.parse(userShiftStatus) : null;
  
  // Use shiftReportDetails if available, otherwise use fallback data
  const shiftId = shiftReportDetails?.shiftId || shiftData?.shiftId || 'N/A';
  const employeeName = shiftReportDetails?.employeeName || userInfo?.userName || 'Unknown';
  const startDate = shiftReportDetails?.startDate || shiftData?.startDate || today;
  const startTime = shiftReportDetails?.startTime || shiftData?.startTime || '';
  const endDate = shiftReportDetails?.endDate || today;
  const endTime = shiftReportDetails?.endTime || '';
  const isActiveShift = !shiftReportDetails?.endDate;

  // Get all checked-in employees from checkin summary
  const empCheckInList = shiftReporCheckinSummary?.empCheckIn || [];
  
  // Helper to safely convert time to AM/PM format
  const formatTime = (time) => {
    if (!time) return getCurrentTime();
    try {
      // If time is already in string format and has ":", try to convert
      if (typeof time === 'string' && time.includes(':')) {
        return convertToAMPM(time);
      }
      return time;
    } catch (error) {
      console.error('Error converting time:', error);
      return getCurrentTime();
    }
  };
  
  return (
    <div className='flex-column  shift-report-print-header'>
        <div className='flex-column justify-center'>
            <img src={companyProfile?.logo} alt="" />
            <p className="head">{companyProfile?.companyName}</p>
            <p className="address">
                {companyProfile?.companyAddress}
                <br />
                {companyProfile?.country}
                <br />
                {companyProfile?.companyEmail}
                <br />
                {companyProfile?.contactNumber}
                </p>
        </div>

        <div className="flex-colum shift-details">
            <p>SHIFT &nbsp;&nbsp;: {`${shiftId}-${employeeName}`}</p>
            <p>START : {`${startDate} - ${formatTime(startTime)}`}</p>
            <p>END &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;: {isActiveShift ? "Active Shift" : `${endDate} - ${formatTime(endTime)}`}</p>
        </div>
        
        <div className="flex-colum shift-details" style={{ marginTop: '10px', borderTop: '1px dashed #ccc', paddingTop: '10px' }}>
            <p style={{ fontWeight: 'bold', marginBottom: '5px' }}>CHECKOUT INFORMATION</p>
            {empCheckInList.length > 0 ? (
              empCheckInList.map((emp, idx) => {
                const name = emp?.empData?.staff_name || emp?.employeeName || 'Unknown';
                const checkInDate = emp?.checkInDate || startDate;
                const checkInTime = emp?.checkInTime || '';
                const checkOutDate = emp?.checkOutDate;
                const checkOutTime = emp?.checkOutTime;
                const hasCheckedOut = checkOutDate && checkOutDate !== 'null' && checkOutDate !== 'Invalid date';
                const isSameEmployee = true;
                const isSameDate = hasCheckedOut && checkOutDate === checkInDate;
                return (
                  <div key={idx} style={{ marginBottom: idx < empCheckInList.length - 1 ? '8px' : '0', paddingBottom: idx < empCheckInList.length - 1 ? '8px' : '0', borderBottom: idx < empCheckInList.length - 1 ? '1px dotted #ddd' : 'none' }}>
                    <p>Checked In By: {name}</p>
                    <p>Check-In Date: {checkInDate} at {formatTime(checkInTime)}</p>
                    {hasCheckedOut ? (
                      isSameDate ? (
                        <p>Check-Out Time: {formatTime(checkOutTime)}</p>
                      ) : (
                        <p>Check-Out Date: {checkOutDate} at {formatTime(checkOutTime)}</p>
                      )
                    ) : (
                      <p>Check-Out: Not Yet</p>
                    )}
                  </div>
                );
              })
            ) : (
              <>
                <p>Checked In By: {employeeName}</p>
                <p>Check-In Date: {startDate} at {formatTime(startTime)}</p>
                <p>Checked Out By: {employeeName}</p>
                <p>Check-Out Date: {isActiveShift ? "Not Yet" : `${endDate} at ${formatTime(endTime)}`}</p>
              </>
            )}
        </div>
    </div>
  )
}

export default AdvncShiftReportHeader